<section
  class="pb-md-7 bg-hero animate__animated animate__fadeIn"
  id="home"
>
  <!-- Capa de fondo anterior (queda debajo durante el crossfade) -->
  <div
    class="hero-bg"
    [style.background-image]="
      prevSection?.imageUrl ? 'url(' + prevSection?.imageUrl + ')' : ''
    "
  ></div>
  <!-- Capa de fondo actual (hace fade-in encima) -->
  <div
    class="hero-bg hero-bg--current"
    [class.hero-bg--fading-in]="isFading"
    (animationend)="onHeroFadeEnd($event)"
    [style.background-image]="
      currentSection?.imageUrl ? 'url(' + currentSection?.imageUrl + ')' : ''
    "
  ></div>
  <div class="hero-bg-overlay"></div>

  <div class="hero-auth-chrome site-content">
    <app-historico-branch></app-historico-branch>
    <app-incomplete-profile-banner></app-incomplete-profile-banner>
  </div>

  <div class="hero-auth-content">
    <div class="site-content">
    <div class="hero-auth-inner">
      <div class="divisa-col-12">
        <h1 class="main-title heading-black mb-0">
          {{
            currentSection?.title ||
              ('LANDING.PRICE_TABLE_AUTH.DEFAULT_HERO_TITLE' | translate)
          }}
        </h1>
        <h2 class="hero-subheading mt-2 mb-0" *ngIf="currentSection?.subtitle">
          {{ currentSection?.subtitle }}
        </h2>
      </div>
      <div class="divisa-space-between mt-5">
        <div
          class="cont-currency-selector divisa-col-7 divisa-col-md-8 my-auto"
        >
          <h6 class="my-auto">{{ 'LANDING.PRICE_TABLE.SELECT_CURRENCY' | translate }}</h6>
        </div>
        <div class="divisa-col">
          <div class="divisa-space-between text-end">
            <div class="divisa-col pr-2">
              <p class="cont-view-title my-auto">
                {{ 'LANDING.PRICE_TABLE_AUTH.SORT_VIEW_LABEL' | translate }}
              </p>
            </div>
            <div class="divisa-col">
              <div class="cont-view-buttons">
                <button
                  class="icon-button-secondary p-0"
                  [ngClass]="{ active: !isList }"
                  (click)="isList = !isList"
                >
                  <mat-icon svgIcon="view_module"></mat-icon>
                </button>
                <button
                  class="icon-button-secondary p-0"
                  [ngClass]="{ active: isList }"
                  (click)="isList = !isList"
                >
                  <mat-icon svgIcon="toc"></mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="divisa-col animate__animated animate__fadeIn"
        *ngIf="divisas && isList"
      >
        <app-divisa-list
          class="py-1"
          *ngFor="let divisa of divisas"
          [divisa]="divisa"
          (divisaSelected)="openDialog($event)"
        ></app-divisa-list>
      </div>
    </div>
    </div>
    <div
      class="card-rail divisa-rail animate__animated animate__fadeIn"
      appCardRail
      *ngIf="divisas && !isList"
      [attr.aria-label]="'LANDING.PRICE_TABLE.SELECT_CURRENCY' | translate"
    >
      <app-divisa-card
        *ngFor="let divisa of divisas"
        [divisa]="divisa"
        (divisaSelected)="openDialog($event)"
      ></app-divisa-card>
    </div>
  </div>
</section>
